import React from 'react';
import { RegionReportList } from '../../RegionReportList/RegionReportList';
import { RegionReportDetail } from '../../RegionReportDetail/RegionReportDetail';
import styles from '../../RegionReport.css';

type RegionReportListProps = React.ComponentProps<typeof RegionReportList>;
type RegionReportDetailProps = React.ComponentProps<typeof RegionReportDetail>;

export type ReportContentViewProps = {
  activity: RegionReportListProps['activity'] | null | undefined;
  cropCode: RegionReportListProps['cropCode'];
  fieldBoundary: RegionReportListProps['fieldBoundary'];
  fieldName: RegionReportListProps['fieldName'];
  index: number;
  isAirSeeder: boolean;
  isDetailView: boolean;
  isListView: boolean;
  itemData: RegionReportDetailProps['itemData'] | null;
  locale: RegionReportListProps['locale'];
  onCancelClick: RegionReportListProps['onCancelClick'];
  onDeleteConfirm: RegionReportListProps['onDeleteClick'];
  onItemClick: RegionReportListProps['onClick'];
  onNotePadClick: RegionReportListProps['onRegionButtonClick'];
  onStep2Click: RegionReportDetailProps['onClick'];
  reportData: RegionReportListProps['data'] | null;
  saveClick: RegionReportListProps['saveClick'];
  showSaveButton: boolean;
};

export const ReportContentView = ({
  activity,
  cropCode,
  fieldBoundary,
  fieldName,
  index,
  isAirSeeder,
  isDetailView,
  isListView,
  itemData,
  locale,
  onCancelClick,
  onDeleteConfirm,
  onItemClick,
  onNotePadClick,
  onStep2Click,
  reportData,
  saveClick,
  showSaveButton,
}: ReportContentViewProps) => (
  <div data-test-id='region-report-form' className={styles.regionReportContainer}>
    {activity && reportData && isListView && (
      <RegionReportList
        activity={activity}
        cropCode={cropCode}
        data={reportData}
        fieldBoundary={fieldBoundary}
        fieldName={fieldName}
        index={index}
        isAirSeeder={isAirSeeder}
        locale={locale}
        onCancelClick={onCancelClick}
        onClick={onItemClick}
        onDeleteClick={onDeleteConfirm}
        onRegionButtonClick={onNotePadClick}
        saveClick={saveClick}
        showSaveButton={showSaveButton}
      />
    )}
    {itemData && isDetailView && (
      <RegionReportDetail
        cropCode={cropCode}
        index={index}
        isAirSeeder={isAirSeeder}
        itemData={itemData}
        onCancelClick={onCancelClick}
        onClick={onStep2Click}
        onDeleteClick={onDeleteConfirm}
        saveClick={saveClick}
        showSaveButton={showSaveButton}
      />
    )}
  </div>
);
